import { Component, OnInit, Input, ViewChild, ElementRef, AfterViewInit, OnChanges } from '@angular/core';
import { Router } from '@angular/router';
import { MapViewService } from 'src/app/shared/components/map-view/map-view.service';
import { SheetsService } from 'src/app/shared/components/sheets/sheets.service';
//import { GoogleAnalyticsService } from 'src/app/shared/services/google-analytics.service';
import { SearchObjectService } from 'src/app/shared/services/search-object.service';

@Component({
  selector: 'app-search-result-card',
  templateUrl: './search-result-card.component.html',
  styleUrls: ['./search-result-card.component.scss']
})
export class SearchResultCardComponent implements OnInit, AfterViewInit, OnChanges {

  isActive = false;
  isMainPosition = false;
  route: string;

  @Input() resultData: any;
  @Input() dataNoMap: boolean;
  @Input() showLevels: boolean;
  @Input() position: number;
  @Input() showPromoted: boolean;
  @Input() activeMarkerLetter: string;
  @Input() activeMarkerPos: number;
  @ViewChild('resultCard', { static: false }) resultCard: ElementRef;


  ngOnChanges() {
    if (this.activeMarkerLetter && this.resultData) {
      this.isActive = (this.activeMarkerLetter === (this.resultData && this.resultData.locations && this.resultData.locations.length !== 0 && (this.resultData.locations[0].officeAddress && this.resultData.locations[0].officeAddress.letter || this.resultData.locations[0].address && this.resultData.locations[0].address.letter)));
      if (this.isActive) {
        if (this.resultCard) {
          setTimeout(() => {
            this.resultCard.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
          }, 0);
        }
      }
    }

    if (this.activeMarkerPos && this.resultData) {
      let oldActive = this.isActive;
      this.isActive = (this.activeMarkerPos == this.resultData.position);
      if (this.activeMarkerPos == this.resultData.position) {
        this.isMainPosition = true;
      } else {
        this.isMainPosition = false;
      }
    }
  }

  constructor(private router: Router, private sheetsService: SheetsService, private searchObjectService: SearchObjectService,
    //private GAService: GoogleAnalyticsService, 
    private mapViewService: MapViewService) {
  }

  ngOnInit() {
    this.route = window.location.origin + this.router.createUrlTree(['/searchdetails', this.resultData.type, this.resultData.id, this.resultData.networkId], {
      queryParams: {
        address: this.resultData.address ? this.resultData.address : undefined,
        subproductkey: this.searchObjectService.getSubProductKey() ? this.searchObjectService.getSubProductKey() : undefined,
        loginType: this.resultData.loginType ? this.resultData.loginType : undefined,
        searchYear: this.searchObjectService.getSearchYear() ? this.searchObjectService.getSearchYear() : undefined
      }
    });


  }

  ngAfterViewInit(): void {
    if (this.isActive && this.isMainPosition) {
      if (this.resultCard) {
        setTimeout(() => {
          this.resultCard.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        }, 0);
      }
    }
  }

  ngOnDestroy() {

  }

  clickDistance(event) {
    // sheet function
    this.sheetsService.changeSheets(this.resultData);
    event.stopPropagation();
  }

  openHoverSheet(event, title, message) {
    // sheet function
    this.sheetsService.changeSheets({
      isMessage: true,
      title: title,
      message: message
    });
    event.stopPropagation();
  }


  cardClickRoute(event) {
    if (this.resultData && event.view.getSelection().toString().length === 0) {
      this.searchObjectService.updateQueryParams('pos', this.resultData.position);
      this.searchObjectService.setFilterPos(this.resultData.position);
      //this.GAService.pushResultClick(this.resultData, this.searchObjectService.getSearchObject(), this.position);
      this.router.navigate(['/searchdetails', this.resultData.type, this.resultData.id, this.resultData.networkId], {
        queryParams: {
          address: this.resultData.address ? this.resultData.address : undefined,
          subproductkey: this.searchObjectService.getSubProductKey() ? this.searchObjectService.getSubProductKey() : undefined,
          loginType: this.resultData.loginType ? this.resultData.loginType : undefined,
          searchYear: this.searchObjectService.getSearchYear() ? this.searchObjectService.getSearchYear() : undefined
        }
      });
    }
    event.preventDefault();
  }

  setMouseEnter(event) {
    this.resultData.locations[0].isInView = true;
    this.mapViewService.updateMapMarker.emit();
  }

  setMouseLeave(event) {
    this.resultData.locations[0].isInView = false;
    this.mapViewService.updateMapMarker.emit();
  }

}
